/**
 * Auto-pick store language on first visit from browser language, then country.
 * Skips if the visitor already chose a language (selector or prior auto).
 */
(function () {
  if (window.__wod3dLocaleAutoBooted) return;
  window.__wod3dLocaleAutoBooted = true;

  const cfg = window.wod3dLocalization;
  if (!cfg || !Array.isArray(cfg.languages) || cfg.languages.length < 2) return;
  if (window.Shopify?.designMode) return;

  const STORAGE_KEY = 'wod3d_locale_choice';
  const AUTO_KEY = 'wod3d_locale_auto_v1';

  try {
    if (sessionStorage.getItem(AUTO_KEY) === '1') return;
    if (localStorage.getItem(STORAGE_KEY)) return;
  } catch (_) {
    return;
  }

  const available = cfg.languages
    .map((l) => String(l.iso || '').trim())
    .filter(Boolean);
  if (!available.length) return;

  const current = normalize(cfg.currentLocale || '');

  function normalize(code) {
    return String(code || '').trim().replace('_', '-');
  }

  function primary(code) {
    return normalize(code).toLowerCase().split('-')[0];
  }

  function findAvailable(candidate) {
    const raw = normalize(candidate);
    if (!raw) return null;
    const exact = available.find((a) => normalize(a).toLowerCase() === raw.toLowerCase());
    if (exact) return exact;
    const base = primary(raw);
    // Prefer regional match when several share a base (e.g. pt-PT over pt-BR).
    const regional = available.find((a) => normalize(a).toLowerCase() === base);
    if (regional) return regional;
    return available.find((a) => primary(a) === base) || null;
  }

  const COUNTRY_TO_LOCALE = {
    ES: 'es',
    MX: 'es',
    AR: 'es',
    CO: 'es',
    CL: 'es',
    PE: 'es',
    EC: 'es',
    UY: 'es',
    PY: 'es',
    BO: 'es',
    CR: 'es',
    PA: 'es',
    GT: 'es',
    HN: 'es',
    SV: 'es',
    NI: 'es',
    DO: 'es',
    CU: 'es',
    VE: 'es',
    PT: 'pt-PT',
    BR: 'pt-BR',
    AO: 'pt-PT',
    MZ: 'pt-PT',
    DE: 'de',
    AT: 'de',
    LI: 'de',
    FR: 'fr',
    BE: 'fr',
    LU: 'fr',
    MC: 'fr',
    GB: 'en',
    US: 'en',
    IE: 'en',
    AU: 'en',
    NZ: 'en',
    CA: 'en',
    CH: null, // multilingual; rely on browser language
  };

  function browserCandidates() {
    const list = [];
    if (Array.isArray(navigator.languages)) list.push(...navigator.languages);
    if (navigator.language) list.push(navigator.language);
    return list.map(normalize).filter(Boolean);
  }

  let target = null;
  for (const lang of browserCandidates()) {
    target = findAvailable(lang);
    if (target) break;
  }

  if (!target) {
    const country = String(cfg.country || '').toUpperCase();
    const mapped = COUNTRY_TO_LOCALE[country];
    if (mapped) target = findAvailable(mapped);
  }

  if (!target) return;
  if (primary(target) === primary(current) && normalize(target).toLowerCase() === normalize(current).toLowerCase()) {
    try {
      sessionStorage.setItem(AUTO_KEY, '1');
    } catch (_) {}
    return;
  }
  // Same language family already showing (es vs es-ES) — don't bounce.
  if (primary(target) === primary(current)) {
    try {
      sessionStorage.setItem(AUTO_KEY, '1');
    } catch (_) {}
    return;
  }

  const form = document.getElementById('Wod3dLocaleAutoForm');
  const input = form?.querySelector('input[name="locale_code"]');
  if (!form || !input) return;

  try {
    localStorage.setItem(STORAGE_KEY, target);
    sessionStorage.setItem(AUTO_KEY, '1');
  } catch (_) {}

  input.value = target;
  form.submit();
})();
